import type { IAdminMedicationDetails } from 'infrastructure/interfaces';

export const transformMedicationDetailTextField = (
  medication: IAdminMedicationDetails | null | undefined,
): IAdminMedicationDetails | null | undefined => {
  if (!medication) {
    return medication;
  }

  return {
    ...medication,
    name: medication.name || '-',
    manufacturer: medication.manufacturer || '-',
    couponDescription: medication.couponDescription || '-',
  };
};

export const revertMedicationDetailTextField = (
  medication: IAdminMedicationDetails | null | undefined,
): IAdminMedicationDetails | null | undefined => {
  if (!medication) {
    return medication;
  }

  return {
    ...medication,
    name: medication.name === '-' ? '' : medication.name,
    manufacturer:
      medication.manufacturer === '-' ? '' : medication.manufacturer,
    couponDescription:
      medication.couponDescription === '-' ? '' : medication.couponDescription,
  };
};
